module.exports = __webpack_public_path__ + "static/media/youtube_link.6e966ccc.svg";